import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealthAndBeautyinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M27 46H15.25c-1.243 0-2.25-.977-2.25-2.182V24.182C13 22.977 14.007 22 15.25 22h13.5c1.243 0 2.25.977 2.25 2.182v1.578" }),
			/* @__PURE__ */ _jsx("path", { d: "M27 52H11.615C9.066 52 7 49.985 7 47.5v-27c0-2.485 2.066-4.5 4.615-4.5h20.77C34.934 16 37 18.015 37 20.5V26" }),
			/* @__PURE__ */ _jsx("rect", {
				x: 11,
				y: 7,
				width: 20,
				height: 4,
				rx: 2
			}),
			/* @__PURE__ */ _jsx("path", { d: "M14 11v4m14-4v4" }),
			/* @__PURE__ */ _jsx("rect", {
				x: 27,
				y: 33,
				width: 30,
				height: 24,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 27,
				y: 27,
				width: 30,
				height: 6,
				rx: 3
			})
		]
	})
});
export default SvgHealthAndBeautyinline;
